import * as React from "react";
import { IOffStreetParking } from "types";
import { Button } from "@/components/ui/button";
import useToggle from "hooks/use-toggle";
import { moneyFormat, numberFormat } from "helper/format-data";
import { OffStreetParkingModalState } from "../off-street-parking.const";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export type OffStreetParkingDetailProps = {
  parking: IOffStreetParking;
  setParkingModalState: React.Dispatch<React.SetStateAction<keyof typeof OffStreetParkingModalState>>;
  removeParking: () => void;
  onClose: () => void;
};
export const OffStreetParkingDetail = ({
  parking,
  setParkingModalState,
  removeParking,
  onClose,
}: OffStreetParkingDetailProps) => {
  const [openConfirm, setOpenConfirm] = useToggle(false);

  const handleOpenConfirm = () => {
    setOpenConfirm();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className="transition-opacity absolute h-auto top-20 bg-primary p-3 right-80 mt-4 mb-3 rounded-md shadow-lg z-5 min-w-80">
        <div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Name</span>
            <span className="text-sm text-secondary">{parking.name}</span>
          </div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Address</span>
            <span className="text-sm text-secondary">{parking.address}</span>
          </div>
          {!!parking.totalPlaces && (
            <div className="flex justify-between w-full items-center py-2">
              <span className="text-sm text-secondary">Parking capacity</span>
              <span className="text-sm text-secondary">{numberFormat(parking.totalPlaces)}</span>
            </div>
          )}
          {!!parking.pricePerHour && (
            <div className="flex justify-between w-full items-center py-2">
              <span className="text-sm text-secondary">Price per hour</span>
              <span className="text-sm text-secondary">{moneyFormat(parking.pricePerHour)}</span>
            </div>
          )}
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">External Id</span>
            <span className="text-sm text-secondary">{parking.externalId}</span>
          </div>
        </div>
        <div className="flex justify-between mt-4">
          <Button onClick={handleOpenConfirm} variant="destructive">
            Delete
          </Button>
          <Button onClick={() => setParkingModalState(OffStreetParkingModalState.SHOW)} variant="secondary">
            Edit
          </Button>
          <Button onClick={handleClose} variant="secondary">
            Close
          </Button>
        </div>
      </div>
      <AlertDialog open={openConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete private parking</AlertDialogTitle>
            <AlertDialogDescription>Are you sure that you want to delete this parking?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleOpenConfirm}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={removeParking}>Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
